document.getElementById("shipping_address").addEventListener("change", function () {
    var fields = document.getElementById("shipping_address_fields");
    fields.style.display = this.checked ? "block" : "none";
});

document.addEventListener("DOMContentLoaded", function () {
    const inputFields = document.querySelectorAll(".quantity__input");

    inputFields.forEach(input => {
        const savedValue = sessionStorage.getItem(input.id);
        if (savedValue !== null) {
            input.value = savedValue;
        }
        input.addEventListener("input", () => {
            sessionStorage.setItem(input.id, input.value);
            updateOrderSummary();
        });
        input.closest(".quantity").querySelectorAll("button").forEach(button => {
            button.addEventListener("click", () => {
                setTimeout(() => {
                    sessionStorage.setItem(input.id, input.value);
                }, 10);
            });
        });
    });
    updateOrderSummary();
    const form = document.getElementById("B2BOrderForm");

    form.addEventListener("submit", function (event) {
        event.preventDefault();
        const comment = document.querySelector("#B2BOrderForm-body").value || "";
        let shippingAddress = "";
        if (document.getElementById("shipping_address").checked) {
            const shippingStreet = document.querySelector("#B2BOrderForm-shipping-street").value || "";
            const shippingPostalCode = document.querySelector("#B2BOrderForm-shipping-postal-code").value || "";
            const shippingCity = document.querySelector("#B2BOrderForm-shipping-city").value || "";
            shippingAddress = shippingStreet + "\n" + shippingPostalCode + " " + shippingCity;
        } const products = getSelectedProducts();
        const productDetails = formatProductDetails(products);
        const subtotal = document.getElementById("subtotal").innerText;
        const vat = document.getElementById("vat").innerText;
        const total = document.getElementById("total").innerText;

        const combinedComment =
            comment + "\n\n" + "Bestelde Producten:\n" + productDetails + "\n\n Subtotaal: €" + subtotal + "\n BTW: €" + vat + "\n Totaal: €" + total;

        document.getElementById("B2BOrderForm-body").value = combinedComment;
        form.submit();
        sessionStorage.clear();
    });

    document.querySelectorAll('.quantity__input').forEach(input => {
        input.addEventListener('input', updateOrderSummary);
        input.addEventListener('change', updateOrderSummary);
    });
    document.getElementById("clearCart").addEventListener("click", function() {
        sessionStorage.clear();
        document.querySelectorAll(".quantity__input").forEach(input => {
            input.value = 0;
        });
        updateOrderSummary();
    });
});

function getSelectedProducts() {
    const quantityInputs = document.querySelectorAll('.quantity__input');
    const groupedProducts = {};    
    document.querySelectorAll('.quantity-badge').forEach(badge => {
        badge.innerText = "0";
        badge.style.display = "none";
    });

    quantityInputs.forEach(input => { 
        const quantity = parseInt(input.value, 10);
        if (quantity > 0) {
            const label = input.closest('label');
            const variantName = label ? label.childNodes[0].textContent.trim() : null;
            const productDiv = input.closest('.product');
            const productName = productDiv ? productDiv.querySelector('h4.product__title').textContent.trim() : null;
            const price = parseFloat(input.dataset.price || 0);
            const totalPrice = price * quantity;

            if (productName && variantName) {
                if (!groupedProducts[productName]) {
                    groupedProducts[productName] = {
                        productName,
                        price,
                        orders: [],
                        id: input.id.split('-')[0],
                    };
                }
                groupedProducts[productName].orders.push({
                    variantName,
                    quantity,
                    totalPrice,
                });
            }
        }
    });
    return Object.values(groupedProducts);
}

function formatProductDetails(products) {
    return products.map((product) => {
        const variantDetails = product.orders.map(order =>
            (order.quantity + ' x ' + order.variantName + ',  —  €' + order.totalPrice)
        ).join("\n")

        return `${product.productName}\n${variantDetails}`;
    })
        .join("\n\n");
}

function updateOrderSummary() {
    const products = getSelectedProducts();
    const subtotal = generateOrderTable(products);
    const subtotalEl = document.getElementById("subtotal");
    const vatEl = document.getElementById("vat");
    const totalEl = document.getElementById("total");
    const vat = subtotal * 0.21;
    const total = subtotal + vat;
    subtotalEl.innerText = subtotal.toFixed(2);
    vatEl.innerText = vat.toFixed(2);
    totalEl.innerText = total.toFixed(2);
}

function generateOrderTable(products) {
    const table = document.querySelector("#orderList tbody");
    table.innerHTML = "";
    let subtotal = 0;
    products.forEach(product => {
        const productRow = document.createElement("tr");
        productRow.classList.add('orderlist-product-row')
        productRow.innerHTML = `<td colspan="3"><strong>${product.productName}</strong></td>`;
        table.appendChild(productRow);
        product.orders.forEach(order => {
            const totalPrice = order.totalPrice;
            const row = document.createElement("tr");
            row.classList.add('orderlist-sub-row')
            row.innerHTML = `
                <td>${order.variantName}</td>
                <td>${order.quantity} x</td>
                <td>€ ${totalPrice.toFixed(2)}</td>
            `;
            table.appendChild(row);
            subtotal += totalPrice;
        });
        const badge = document.querySelector(`#quantityBadge-${product.id}`);
        const totalQuantity = product.orders.reduce((sum, order) => sum + (order.quantity || 0), 0);

        if (badge) {
            if (totalQuantity) {
                badge.innerText = totalQuantity;
                badge.style.display = "flex";
            } else {
                badge.style.display = "none";
            }
        }
    });
    return subtotal
}
